module.exports = __webpack_public_path__ + "media/images/lb/816-9df78c8a110f8a43892ad7627327d7fc.svg";